import { render, staticRenderFns } from "./CbxOwner.vue?vue&type=template&id=fc1dd530&"
import script from "./CbxOwner.vue?vue&type=script&lang=ts&"
export * from "./CbxOwner.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports